import React from 'react';

import Quote from 'icons/quote.svg';

import { IQuote } from '../../interfaces';

interface Props {
  title?: string;
  quote: IQuote;
  onLinkClick?: () => void;
}

export const LandingQuote = ({ title, quote, onLinkClick = () => {} }: Props) => {
  return (
    <div className="quote-block quote-block">
      {title && <h4 className="quote-block-title">{title}</h4>}
      <div className="quote-block-text">
        <Quote />
        <p className="body-3 bold black">{quote.fieldQuote}</p>
      </div>
      <div className="quote-block-author">
        <div className="quote-block-author-text">
          {quote.fieldQuoteAuthor && <p className="body-3 bold black">{quote.fieldQuoteAuthor}</p>}
          {quote.fieldQuotePosition && <p className="caption quote-block-position">{quote.fieldQuotePosition}</p>}
        </div>
      </div>
      {quote.quoteLink && (
        <div className="quote-block-link">
          <a
            href={quote.quoteLink || ''}
            target="_blank"
            rel="noreferrer"
            aria-label="Read original review"
            onClick={onLinkClick}
          >
            {quote.quoteLinkDescription}
          </a>
        </div>
      )}
    </div>
  );
};
